import createComponent, {
  ElementWithProps
} from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const HeroWrapper = createComponent('div', {
  className: 'relative grid'
});

export const HeroContentWrapper = createComponent('div', {
  className:
    'col-span-full row-span-full flex flex-col justify-between px-2xl pb-2xl pt-4xl sm:px-3xl sm:pb-3xl md:items-center md:justify-end md:px-4xl'
});

export const HeroContentContainer = createComponent('div', {
  className:
    'grid h-full w-full max-w-[1272px] content-between gap-8xl md:h-fit'
});

export const HeroTitle = createComponent<
  ElementWithProps<{ isInComposerTreatment: boolean }>
>('h1', props => ({
  className: cx(
    'text-text-inverse sm:t-brand-lg',
    props.isInComposerTreatment ? 't-brand-md' : 't-brand-sm'
  )
}));

export const HeroImage = createComponent('div', {
  className:
    'col-span-full row-span-full h-[460px] w-full sm:h-[545px] md:h-[600px]'
});

export const CtaCardWrapper = createComponent('div', {
  className: 'hidden grid-cols-2 gap-xl sm:grid md:gap-2xl'
});

export const TranslucentCard = createComponent<
  ElementWithProps<{ rounded: 'md' | 'lg' }>
>('div', props => ({
  className: cx(
    'relative [&>*]:relative [&>*]:z-[1]',
    props.rounded === 'md'
      ? 'rounded:md after:rounded-md'
      : 'rounded:lg after:rounded-lg',
    `
    after:absolute
    after:inset-0
    after:rounded-lg
    after:border
    after:border-border-inverse-transparent
    after:bg-white
    after:opacity-90
    after:backdrop-blur
    after:content-['']
    after:supports-[backdrop-filter:blur(8px)]:bg-[rgba(0,0,0,0.25)]
    after:supports-[backdrop-filter:blur(8px)]:opacity-[initial]`
  )
}));
